import { AccountMenuService } from '@account/services';
import { AccountShowView as AccountModuleAccountShowView } from '@account/views/employee/account/show/account-show.view';
import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvents, FeatureFlag } from '@app/enums';
import { AnalyticService, AuthService, NotifyService, SettingsService, TranslationStorageService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { Account } from '@models/account/account.model';

@Component({
    templateUrl: './show.template.html',
    styleUrls: ['./show.style.scss', '../../../../../styles/shared-views/profile-account.scss'],
    /**
     * Only doing this because this extends a view from the Account Module (which we shouldn't have done...)
     */
    providers: [{ provide: AccountMenuService, useValue: null }],
})
export class AccountShowView extends AccountModuleAccountShowView {
    updateAccountPermission = Account.permission.edit;

    isSelfEmployeeView = false;
    isKYCKYBFlagEnabled = false;

    constructor(
        public route: ActivatedRoute,
        public tabMenuService: AccountMenuService,
        protected auth: AuthService,
        protected element: ElementRef,
        protected notify: NotifyService,
        protected settingsService: SettingsService,
        protected analyticsService: AnalyticService,
        public translationStorage: TranslationStorageService,
        public featureService: FeatureService
    ) {
        super(
            route,
            tabMenuService,
            auth,
            element,
            notify,
            settingsService,
            analyticsService,
            translationStorage,
            featureService
        );

        featureService
            .has(FeatureFlag.KYC_KYB)
            .then((isKYCKYBFlagEnabled) => (this.isKYCKYBFlagEnabled = isKYCKYBFlagEnabled));
    }

    addPendoTrackingForClickSignInAsEmployee(): void {
        this.analyticsService.trackEvent(AnalyticEvents.EmployeeProfileAccountTabClickSignInAsEmployee);
    }

    signInAs(): void {
        this.isLoading = true;
        this.auth
            .authenticateWithAccountId(this.account.id)
            .catch((err) => this.notify.error(err || 'employees.account.unableToSignIn'))
            .finally(() => (this.isLoading = false));
    }

    changeLock(): void {
        this.account.isLocked = !this.account.isLocked;

        // Pendo Tracking
        if (!this.account.isLocked) {
            this.analyticsService.trackEvent(AnalyticEvents.EmployeeProfileAccountTabClickUnlock);
        } else {
            this.analyticsService.trackEvent(AnalyticEvents.EmployeeProfileAccountTabClickLockAccount);
        }

        this.account
            .save()
            .then(() =>
                this.notify.success(
                    this.account.isLocked
                        ? 'employees.account.accountHasBeenLocked'
                        : 'employees.account.accountHasBeenUnlocked'
                )
            )
            .catch((err) => this.notify.error(err || 'employees.account.unableToUpdateAccount'));
    }

    copyActivationLink(): void {
        if (!this.activationLink || !this.activationLink.link) {
            return;
        }

        const element = document.createElement('textarea');
        element.value = this.activationLink.link;
        element.style.height = '1px';
        element.style.width = '1px';
        document.body.appendChild(element);
        element.select();
        document.execCommand('copy');
        document.body.removeChild(element);

        this.notify.info('employees.account.activationLinkCopiedToClipboard');
    }
}
